<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="'发运单编号 搜索...'"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      top="10vh"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" label-position="top" size="mini">
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item
              :label="$l('INDEX.form_label_shipmentNo') || '发运单编号'"
            >
              <el-input
                v-model.trim="form.shipmentNo"
                :placeholder="
                  $l('INDEX.form_Please_shipmentNo') || '请输入发运单编号'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item :label="$l('INDEX.table_label_custName') || '客户'">
              <dict-select
                url="/master/common/dict/customerSelect"
                v-model="form.listCustCode"
                :placeholder="
                  $l('INDEX.form_label_please_select_a_customer') ||
                    '请选择客户'
                "
                size="mini"
                clearable
                filterable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item
              :label="$l('INDEX.table_label_endcustomer_name') || '终端客户'"
            >
              <dict-select
                url="/master/common/dict/customerSelect"
                v-model="form.listEndCustCode"
                :placeholder="
                  $l('INDEX.form_label_please_select_a_customer') ||
                    '请选择客户'
                "
                size="mini"
                clearable
                filterable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item
              :label="$l('INDEX.order_form_label_shipmentType') || '发运方式'"
            >
              <dict-select
                filterable
                size="mini"
                clearable
                multiple
                v-model.trim="form.listShipmentType"
                :body="shipmentTypeParams"
                url="/master/common/dict/biz"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="$l('INDEX.order_form_label_orderScmCode') || '名义工厂'"
            >
              <dict-select
                clearable
                size="mini"
                filterable
                multiple
                v-model="form.listOrderScmCode"
                url="/master/common/dict/scmPartners"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="
                $l('INDEX.order_form_batch_label_dispatchPort') || '发运港口'
              "
            >
              <dict-select
                v-model="form.listDispatchPort"
                url="/master/port/select"
                filterable
                multiple
                clearable
                size="mini"
                :placeholder="
                  $l('INDEX.form_placeholder_dispatchPort') || '请选择发运港口'
                "
              >
              </dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="
                $l('INDEX.order_form_batch_label_destinationPort') || '目的港口'
              "
            >
              <dict-select
                url="/master/port/select"
                v-model="form.listDestinationPort"
                :placeholder="
                  $l('INDEX.placeholder_destinationPort') || '请选择目的港口'
                "
                filterable
                multiple
                clearable
                size="mini"
              >
              </dict-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-row>
              <el-form-item
                :label="$l('INDEX.form_label_plannedETD') || '计划发运日期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.plannedETDStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.plannedETDEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>

          <el-col :span="8">
            <el-row>
              <el-form-item :label="$l('INDEX.create_date') || '创建时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createStartTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createEndTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="8">
            <el-row>
              <el-form-item
                :label="$l('INDEX.form_label_modification_time') || '修改时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyStartTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyEndTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="8">
            <el-row>
              <el-form-item
                :label="$l('INDEX.form_label_cargoReadyDay') || '货好时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.deliveryStartDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="deliveryStartDatePicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.deliveryEndDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="deliveryEndDatePicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
}
export default {
  data() {
    return {
      shipmentStatusParams: { dictType: 'shipmentStatus' },
      shipmentTypeParams: { dictType: 'shipmentType' },
      shipperParams: { shipmentType: 'S' },
      consigneeParams: { shipmentType: 'C' },
      notifierParams: { shipmentType: 'C' },
      advqueryDialogVisible: false,
      form: { ...initForm },
      deliveryStartDatePicker: this.deliveryEndDate(),
      deliveryEndDatePicker: this.deliveryStartDate(),
    }
  },
  created() {
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    deliveryStartDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.deliveryStartDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.deliveryStartDate).getTime() -
                3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    deliveryEndDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.deliveryEndDate) {
            //如果结束时间不为空，则小于结束时间
            return (
              new Date(self.form.deliveryEndDate).getTime() < time.getTime()
            )
          }
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
